<template>
    <div>
        <ModalLista v-if="showModalLista" @close="closeModalLista()" />

        <footer class="footer">
            <div class="principal usuario">
            <a class="logo-footer brown-text text-lighten-3" href="index.html">
                <strong>BePros© {{ new Date().getFullYear() }} </strong>
            </a>
            <a class="correos" @click="openModalLista()">
                <span>Quiero recibir información</span>
            </a>
            </div>
        </footer>
    </div>
</template>
<script>
import ModalLista from "./ModalListaCorreos";

export default {
components:{
    ModalLista,
},
data(){
    return {
        showModalLista: false,
    }
},
methods:{
    openModalLista() {
      this.showModalLista = true;
    },
    closeModalLista() {
      this.showModalLista = false;
    },
}
}
</script>
<style scoped>
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;

  background: var(--color-estructura-a);
  box-shadow: 0px -5px 5px 0px rgba(0, 0, 0, 0.75);
  z-index: 15;
  padding-left: 5%;
  padding-right: 5%;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  color: white;
}

.footer .principal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.principal{
  background: transparent;
}

.correos {
  cursor: pointer;
}
</style>